export default __webpack_public_path__ + "fonts/ABBvoice_W_Lt-2oUHG.woff2";